import React from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { PLAN_COMPARISON_ROWS } from '../../utils/planCommercialUx';
import { PLAN_IDS, planLabel } from '../../utils/planDetails';

function CellValue({ value }) {
  if (value === true) {
    return (
      <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-emerald-500/20 text-emerald-300" aria-label="Incluido">
        <FaCheck className="h-3.5 w-3.5" />
      </span>
    );
  }
  if (value === false) {
    return (
      <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-white/10 text-e0e3-muted" aria-label="No incluido">
        <FaTimes className="h-3 w-3" />
      </span>
    );
  }
  return <span className="text-sm font-semibold text-e0e3-foreground">{value}</span>;
}

/**
 * Tabla comparativa START / PRO / EMPRESA (solo UX comercial).
 */
export default function PlanesComparisonTable({ highlightPlan = null, compact = false }) {
  return (
    <div className="overflow-x-auto rounded-2xl border border-white/10 bg-white/[0.03]">
      <table className={`w-full min-w-[520px] border-collapse text-left ${compact ? 'text-xs' : 'text-sm'}`}>
        <thead>
          <tr className="border-b border-white/10 bg-white/[0.04]">
            <th scope="col" className="px-3 py-3 font-semibold text-e0e3-muted sm:px-4">
              Qué incluye
            </th>
            {PLAN_IDS.map((id) => (
              <th
                key={id}
                scope="col"
                className={[
                  'px-3 py-3 text-center font-bold sm:px-4',
                  highlightPlan === id ? 'bg-e0e3-accent/15 text-e0e3-accent-soft' : 'text-e0e3-foreground'
                ].join(' ')}
              >
                {planLabel(id)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {PLAN_COMPARISON_ROWS.map((row, idx) => (
            <tr
              key={row.label}
              className={idx % 2 === 0 ? 'bg-transparent' : 'bg-white/[0.02]'}
            >
              <th scope="row" className="px-3 py-2.5 font-medium text-e0e3-foreground sm:px-4 sm:py-3">
                {row.label}
              </th>
              {PLAN_IDS.map((id) => (
                <td
                  key={id}
                  className={[
                    'px-3 py-2.5 text-center sm:px-4 sm:py-3',
                    highlightPlan === id ? 'bg-e0e3-accent/[0.06]' : ''
                  ].join(' ')}
                >
                  <CellValue value={row[id]} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
